import seoConfig from "@/seo/seoConfig.json";
import { scoreRouteStubs } from "@/seo/scorePages";

/**
 * La table des routes du site : celles de seoConfig.json, et les pages de
 * score produites par scorePages.js, rangées juste après la table allemande —
 * l'ordre compte, c'est celui des balises hreflang et des contrôles du build.
 *
 * Tout ce qui cherche une route par son chemin passe par ici, et non par
 * seoConfig.json directement : sans quoi une page de score serait inconnue de
 * Seo.jsx, qui la passerait en noindex, et de LanguageProvider, qui lui
 * refuserait sa langue.
 *
 * Les routes de score n'ont ni titre ni description ici : la page les calcule
 * (CheckoutScorePage), le prérendu les reçoit de checkoutPages.js.
 */
const ANCRE = "/de/dart-checkout-tabelle";

/** `extra` insérées après ANCRE dans `hand`, sans toucher à l'ordre du reste. */
export function withScoreRoutes(hand, extra) {
    if (Object.keys(extra).length === 0) return hand;
    if (!hand[ANCRE]) throw new Error(`routes : ${ANCRE} absente de seoConfig, ou ranger les pages de score ?`);
    const merged = {};
    for (const [path, meta] of Object.entries(hand)) {
        merged[path] = meta;
        if (path === ANCRE) Object.assign(merged, extra);
    }
    return merged;
}

export const baseUrl = seoConfig.baseUrl;
export const routes = withScoreRoutes(seoConfig.routes, scoreRouteStubs());
